export default {
      id: "facebook-usage",
      viewBox: "0 0 11 22",
      url: __webpack_public_path__ + "sprite.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }